import styled, { css } from 'styled-components';
import { colors } from 'src/config/colors';
import {
  Checkbox,
  CheckboxInputWrapper,
  CheckboxLabelText,
  CheckboxRect,
} from 'src/common/components/Checkbox';
import { typography } from 'src/config/typography';
import { media } from 'src/config/breakpoints';

export const CourseListingFilter = styled.div`
  padding-bottom: 1.5rem;
  padding-left: 0.25rem;

  ${media.w.min.px768(css`
    padding-bottom: 1.25rem;
  `)};

  ${media.w.min.px992(css`
    padding-bottom: 3.5rem;
  `)};
`;

export const CourseListingFilterCheckbox = styled(Checkbox)`
  ${CheckboxInputWrapper} {
    padding-right: 0.75rem;
  }
`;

export const CourseListingFilterList = styled.div`
  ${media.w.max.px992(css`
    padding-left: 2.25rem;
  `)};
`;

export const CourseListingFilterItem = styled.div<{ active?: boolean }>`
  margin-bottom: 0.625rem;

  &:last-child {
    margin-bottom: 0;
  }

  ${CheckboxLabelText} {
    color: ${({ active }) => (active ? colors.blue : colors.blue05)};
    font-family: ${typography.fontFamilyDefault};
  }

  ${CheckboxRect} {
    stroke: ${({ active }) => (active ? colors.blue : colors.darkGrey)};
    stroke-width: 0.125rem;
  }
`;

export const CourseListingFilterTitle = styled.div`
  align-items: center;
  color: ${colors.blue};
  display: flex;
  font-weight: 600;
  letter-spacing: 0.15em;
  margin-bottom: 1.5rem;
  text-transform: uppercase;

  svg {
    display: block;
    margin-right: 0.75rem;
  }
`;
